import { useState, useMemo } from "react";
import moment from "moment";
import { switchString } from "../../utils/utils";
import { Button, Checkbox, Modal } from "src/components";
import InvoiceDropdown from "./invoice-menu.component";
import downArrow from "src/assets/down-arrow.svg";
import { useNavigate } from "react-router-dom";
import InvoiceReject from "../invoice-details/invoice-reject";
import InvoiceReassign from "../invoice-master/InvoiceReassign";
import InvoiceRejectionRevoke from "../invoice-master/InvoiceRejectionRevoke";
import Contact from "src/assets/Contact.svg";
import { downloadInvoice } from "src/services/invoice-api";
import InvoiceEscalate from "../invoice-master/InvoiceEscalate";
import InvoiceSetPriority from "../invoice-master/InvoiceSetPriority";
import star from "src/features/fields/assets/star.svg";
import starEmpty from "src/assets/starEmpty.svg";
import InvoiceOnHold from "../invoice-master/InvoiceOnHold";
import Download from "src/features/fields/assets/Download copy.svg";
import Reject from "src/features/fields/assets/Reject.svg";
import Escalate from "src/features/fields/assets/Escalate.svg";
import Priority from "src/features/fields/assets/Priority.svg";
import Hold from "src/features/fields/assets/Hold.svg";
import { useToast } from "src/hooks/useToast";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import EscalatedToCompany from "../invoice-details/invoice-escalatedToCompany";
import { counterActions } from "src/context/counter-slice";
import { latestRemarks } from "../invoice-master/invoice-helper";// M10-13315
import RejectionDetailsCard, { shouldShowRejectionDetails } from "./RejectionDetailsCard"; //M10-15065 //M10-16197
//M10-15065

interface InvoiceDetailCardProps {
  status: string;
  data: any;
  checkDataType: boolean;
  viewDetails?: boolean;
  isExpandable?: boolean;
  isExpandedInitial?: boolean;
  isEntry?: boolean;
  index?: number;
  invoiceData?: any;
  handleAddItem?: any;
  approvalScreen?: boolean;
  isEsalated?: boolean;
  fetchTabData?: () => Promise<void>;
  // REJECTION-REVIEW-WORKFLOW: when true, this card is rendered inside the
  // Rejection Review tab. Disables all entry/edit actions; the parent tab
  // renders Accept/Reject buttons. View Details routes to a restricted view.
  isFuidRejectionReview?: boolean;
  // KAM CN-ADVICE changes: rendered inside the "Feedback from Ext" tab. Adds a badge only —
  // unlike isFuidRejectionReview it must NOT restrict the card's actions, because resolving a
  // stockist issue means reverting and re-entering the invoice from this very card.
  isKamFeedbackExt?: boolean;
}

// M10-16200: category 1 e-invoice status badge colors
const cat1EinvoiceStatusColor: Record<string, string> = {
  pending: "text-[#92400E] bg-[#FEF3C7]",
  accepted: "text-[#207a65] bg-[#d3f6e4]",
  rejected: "text-[#B42318] bg-[#FEE4E2]",
};

const InvoiceHomeDetailCard = ({
  data,
  checkDataType = true,
  status,
  viewDetails = true,
  isExpandable = true,
  isExpandedInitial = false,
  index,
  invoiceData,
  approvalScreen = false,
  fetchTabData,
  isEsalated = true,
  isFuidRejectionReview = false,
  isKamFeedbackExt = false,
}: InvoiceDetailCardProps) => {
  const isRejectionPending = !!invoiceData?.is_rejection_pending;
  const [isExpanded, setIsExpanded] = useState(isExpandedInitial || index === 0);
  const naviagate = useNavigate();
  const [modalStates, setModalStates] = useState({
    reject: false,
    reassign: false,
    hold: false,
    escalate: false,
    setpriority: false,
    removepriority: false,
    escalatedCompany: false, // MEDVOL: M10-11303
    rejectionRevoke: false,
    rejectionReEdit: false,
  });
  const { selectedInvoices } = useSelector((state: RootState) => state.invoice);
  const invoiceKey = invoiceData?.stockist_invoice_attachment_id;
  const { InvoiceFilters } = useSelector((state: RootState) => state.invoice);
  const isSelected = selectedInvoices.some((invoice: any) => invoice.key === invoiceKey && invoice.fuid_no === invoiceData?.fuid_no);
  const dispatch = useDispatch();
  const { toast } = useToast();
  // MEDVOL: M10-11303
  const isEscalationPending = invoiceData?.escalations?.[0]?.escalated_action === "pending";
  const { idTokenDetails } = useSelector((state: RootState) => state.auth); // M10-13620

  const menuItems = [
    { label: "Re-assign Invoice", id: "reassign", icon: Contact },
    { label: "Put On hold", id: "hold", icon: Hold },
    { label: "Reject Invoice", id: "reject", icon: Reject },
    { label: "Escalated To Company", id: "escalated-company", icon: Escalate }, // MEDVOL: M10-11303
    { label: "Download Invoice", id: "download", icon: Download },
    { label: "Download E-Inv Ack", id: "download-ack", icon: Download },
    { label: "Download E-Way Bill", id: "download-eway", icon: Download },
    { label: "Escalate Invoice", id: "escalate", icon: Escalate },
    { label: "Set Priority", id: "setpriority", icon: Priority },
    { label: "Remove Priority", id: "removepriority", icon: Priority },
    { label: "Reject Revoke", id: "rejectionRevoke", icon: Reject },
    { label: "Re-edit Rejection", id: "rejectionReEdit", icon: Reject },
  ].filter(
    (item) => !(isEscalationPending && item.id === "escalated-company")
  );
  // MEDVOL: M10-11303

  const { hasPermission: hasPermissionReassign, loading: reassignPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.REASSIGN.module,
    action: fineGrainedPermissionsKeys.INVOICE.REASSIGN.action,
  });
  const { hasPermission: hasPermissionPutOnHold, loading: putOnHoldPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE["PUT ON HOLD"].module,
    action: fineGrainedPermissionsKeys.INVOICE["PUT ON HOLD"].action,
  });
  const { hasPermission: hasPermissionReject, loading: rejectPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.REJECT.module,
    action: fineGrainedPermissionsKeys.INVOICE.REJECT.action,
  });
  const { hasPermission: hasPermissionEscalate, loading: escalatePermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.ESCALATE.module,
    action: fineGrainedPermissionsKeys.INVOICE.ESCALATE.action,
  });
  const { hasPermission: hasPermissionSetPriority, loading: setPriorityPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE["SETPRIORITY/REMOVEPRIORITY"].module,
    action: fineGrainedPermissionsKeys.INVOICE["SETPRIORITY/REMOVEPRIORITY"].action,
  });

  const isLoadingPermissions =
    reassignPermissionLoading || putOnHoldPermissionLoading || rejectPermissionLoading || escalatePermissionLoading || setPriorityPermissionLoading;

  const company_code = InvoiceFilters?.company?.map((item) => item.code)?.join(",") || 0;

  const permissionMap: Record<string, boolean> = {
    reassign: hasPermissionReassign,
    hold: hasPermissionPutOnHold,
    reject: hasPermissionReject,
    escalate: hasPermissionEscalate,
    setpriority: hasPermissionSetPriority,
    removepriority: hasPermissionSetPriority,
  };

  // REJECTION-REVIEW-WORKFLOW: workflow-action ids that must be blocked while a
  // rejection review is pending OR when this card is rendered inside the FUID
  // Rejection tab. Downloads remain available.
  const blockedWhileRejectionPending = new Set([
    "reject",
    "reassign",
    "hold",
    "escalate",
    "escalated-company",
    "setpriority",
    "removepriority",
    "rejectionRevoke",
  ]);

  const filteredMenuItems = useMemo(() => {
    if (isLoadingPermissions || !invoiceData) return [];

    return menuItems.filter((item) => {
      if (permissionMap.hasOwnProperty(item.id) && !permissionMap[item.id]) {
        return false;
      }

      if (!invoiceData?.is_eway_applicable && item.id === "download-eway") {
        return false;
      }
      if (invoiceData?.is_prioritised && item.id === "setpriority") {
        return false;
      }
      if (!invoiceData?.is_prioritised && item.id === "removepriority") {
        return false;
      }
      if ([2, 4, 5, 8, 9].includes(invoiceData?.fileStatusHdr?.fuid_status_id) && item.id === "reject") {
        return false;
      }
      if ((invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 9) && item.id === "reassign") {
        return false;
      }
      if ((invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 9) && item.id === "hold") {
        return false;
      }
      if ((invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 9) && item.id === "escalate") {
        return false;
      }
      // REJECTION-REVOKE: only available when FUID is in rejected (2) or on-hold (4) state
      if (item.id === "rejectionRevoke" && ![2, 4].includes(invoiceData?.fileStatusHdr?.fuid_status_id)) {
        return false;
      }
      // REJECTION-REVIEW-WORKFLOW: lock down workflow actions while review pending
      if ((isRejectionPending || isFuidRejectionReview) && blockedWhileRejectionPending.has(item.id)) {
        return false;
      }
      // REJECTION-RE-EDIT: only available while a rejection review is pending
      if (item.id === "rejectionReEdit" && !isRejectionPending) {
        return false;
      }
      return true;
    });
  }, [
    invoiceData,
    isLoadingPermissions,
    hasPermissionReassign,
    hasPermissionPutOnHold,
    hasPermissionReject,
    hasPermissionEscalate,
    hasPermissionSetPriority,
    isRejectionPending,
    isFuidRejectionReview,
  ]);

  const verifyStringType = function (input: string) {
    const date = new Date(input);
    const numberRegex = /^\d+$/;
    if (!isNaN(date.getTime()) && input.trim() !== "" && !numberRegex.test(input)) {
      return moment(input).format("DD MMM, YYYY");
    } else {
      return input;
    }
  };

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleCloseModal = (modalName: string) => {
    setModalStates((prev: any) => ({ ...prev, [modalName]: false }));
  };

  const handleOptionClick = (item: any) => {
    switch (item.id) {
      case "reject":
        setModalStates((prev: any) => ({ ...prev, reject: true }));
        break;
      case "hold":
        setModalStates((prev: any) => ({ ...prev, hold: true }));
        break;
      case "reassign":
        setModalStates((prev: any) => ({ ...prev, reassign: true }));
        break;
      // MEDVOL: M10-11303
      case "escalated-company":
        setModalStates((prev: any) => ({ ...prev, escalatedCompany: true }));
        break;
      // MEDVOL: M10-11303
      case "rejectionRevoke":
        setModalStates((prev: any) => ({ ...prev, rejectionRevoke: true }));
        break;
      case "rejectionReEdit":
        setModalStates((prev: any) => ({ ...prev, rejectionReEdit: true }));
        break;
      case "download":
        if (!invoiceData?.file_path) {
          toast({ description: "Invoice not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.file_path, company_code).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the invoice.");
          }
        });
        break;
      case "download-ack":
        if (!invoiceData?.einv_attachment_path) {
          toast({ description: "E-Invoice not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.einv_attachment_path, company_code).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the E-Invoice.");
          }
        });
        break;
      case "download-eway":
        if (invoiceData?.eway_attachment_path == null || invoiceData?.eway_attachment_path == "") {
          toast({ description: "E-Way Bill not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.eway_attachment_path, company_code).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the E-Way Bill.");
          }
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="mb-4">
      <div className="hidden">
        <Modal isOpen={modalStates.reject} isHeader={false} onCloseModal={() => handleCloseModal("reject")} title="Reject Invoice">
          <InvoiceReject
            // company_code={InvoiceFilters?.company}
            // division_code={InvoiceFilters?.division}
            // startDate={InvoiceFilters?.dateRange?.from}
            // endDate={InvoiceFilters?.dateRange?.to}
            // assignee_id={InvoiceFilters?.assignee}
            // city={InvoiceFilters?.city}
            // district={InvoiceFilters?.district}
            // state={InvoiceFilters?.state}
            // ordering={InvoiceFilters?.sorting}
            // status={InvoiceFilters?.status}
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => handleCloseModal("reject")}
            onSuccess={() => fetchTabData?.()}
          />
        </Modal>
        <Modal isOpen={modalStates.reassign} isHeader={false} onCloseModal={() => handleCloseModal("reassign")} title="Reassign Invoice">
          <InvoiceReassign
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("reassign");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.escalate} isHeader={false} onCloseModal={() => handleCloseModal("escalate")} title="Escalate Invoice">
          <InvoiceEscalate
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("escalate");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.setpriority} isHeader={false} onCloseModal={() => handleCloseModal("setpriority")} title="Set Priority">
          <InvoiceSetPriority
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            unset={false}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("setpriority");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.removepriority} isHeader={false} onCloseModal={() => handleCloseModal("removepriority")} title="Remove Priority">
          <InvoiceSetPriority
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            unset={true}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("removepriority");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.hold} isHeader={false} onCloseModal={() => handleCloseModal("hold")} title="Put on hold">
          <InvoiceOnHold
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("hold");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.rejectionRevoke} isHeader={false} onCloseModal={() => handleCloseModal("rejectionRevoke")} title="Revoke Rejection">
          <InvoiceRejectionRevoke
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("rejectionRevoke");
              fetchTabData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.rejectionReEdit} isHeader={false} onCloseModal={() => handleCloseModal("rejectionReEdit")} title="Re-edit Rejection">
          <InvoiceReject
            tab={"entry"}
            mode="rename"
            invoiceData={invoiceData}
            onCloseModal={() => handleCloseModal("rejectionReEdit")}
            onSuccess={() => fetchTabData?.()}
          />
        </Modal>
        {/* MEDVOL: M10-11303 */}
        <Modal isOpen={modalStates.escalatedCompany} isHeader={false} onCloseModal={() => handleCloseModal("escalatedCompany")} title="Escalated to Company">
          <EscalatedToCompany
            company_code={InvoiceFilters?.company}
            division_code={InvoiceFilters?.division}
            startDate={InvoiceFilters?.dateRange?.from}
            endDate={InvoiceFilters?.dateRange?.to}
            assignee_id={InvoiceFilters?.assignee}
            city={InvoiceFilters?.city}
            district={InvoiceFilters?.district}
            state={InvoiceFilters?.state}
            ordering={InvoiceFilters?.sorting}
            status={InvoiceFilters?.status}
            tab={"entry"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("escalatedCompany");
              fetchTabData?.();
            }}
          />
        </Modal>
        {/* MEDVOL: M10-11303 */}
      </div>

      <header className={"flex justify-between w-full px-5 py-3"}>
        <div className="flex items-center gap-x-2">
          {isExpanded && <div className="w-1.5 h-1.5 bg-red-500 rounded-full mr-4"></div>}
          {invoiceData?.fileStatusHdr?.fuid_status_id === 1 && (
            <Checkbox
              checked={isSelected}
              onChange={() =>
                dispatch(
                  invoiceActions.toggleSelectedInvoice({
                    key: invoiceKey,
                    fuid_no: invoiceData?.fuid_no,
                    invoice_assignment_id: invoiceData?.InvoiceAssignment?.invoice_assignment_id,
                  })
                )
              }
              className="mt-4 ml-4"
            />
          )}
          {invoiceData?.is_prioritised && <img src={star} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />}
          {!invoiceData?.is_prioritised && (
            <img src={starEmpty} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />
          )}
          {invoiceData?.fileStatusHdr?.fuid_status_id === 6 || invoiceData?.fileStatusHdr?.fuid_status_id === 8 || invoiceData?.fileStatusHdr?.fuid_status_id === 15 ? ( //M10-10902
            <h1 className={"font-semibold text-[1.2rem] mr-4"}>
              <span className="text-gray-400 text-[1.2rem]">Invoice#</span> {invoiceData?.invoice?.invoice_number}
            </h1>
          ) : (
            <h1 className={"font-semibold text-[1.2rem] mr-4"}>
              <span className="text-gray-400 text-[1.2rem]">FUID#</span> {invoiceData?.fuid_no}
            </h1>
          )}
          <h1
            className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
            style={{ backgroundColor: invoiceData?.fileStatusHdr?.color_code?.trim(), color: invoiceData?.fileStatusHdr?.text_color_code?.trim() }}
          >
            {status}
            <img className="w-3 h-3 ml-1" src={downArrow} alt="down-arrow" />
          </h1>
          <p className="ml-4 text-[#8051FF] text-sm font-semibold border border-gray-400 rounded-full px-2">{invoiceData?.company_name}</p>
          {invoiceData?.is_escalated && isEsalated && (
            <p className="ml-4 text-[#8E1F0B] text-sm font-semibold border bg-[#FEE9E8] rounded-full px-2 py-0.5">Escalated</p>
          )}
          {/* REJECTION-REVIEW-WORKFLOW: visible badge while a rejection review is pending */}
          {isRejectionPending && (
            <p className="ml-4 text-[#92400E] text-sm font-semibold border bg-[#FEF3C7] rounded-full px-2 py-0.5">
              Rejection Review Pending
            </p>
          )}
          {/* REJECTION-REVIEW-WORKFLOW: review completed — warning symbol legend, no text */}
          {!isRejectionPending && invoiceData?.rejectionReviewAssignment?.invoice_assignment_id && (
             <span
              title="Rejection Reviewed"
              className="ml-4 w-3 h-3 rounded-full bg-[#f50505] inline-block"
            />
          )}
          {/* KAM CN-ADVICE changes: flags an invoice the stockist has raised an issue on */}
          {isKamFeedbackExt && (
            <p className="ml-4 text-[#92400E] text-sm font-semibold border bg-[#FEF3C7] rounded-full px-2 py-0.5">
              Ext. Feedback
            </p>
          )}
          {/* textract filter */}
          {invoiceData?.invoice?.textract && (
            <p className="ml-4 text-[#055160] text-sm font-semibold border bg-[#E0F2FE] rounded-full px-2 py-0.5">MV Lens</p> //change name
          )}
          {/* M10-16200: category 1 e-invoice status */}
          {[2, 8].includes(invoiceData?.fileStatusHdr?.fuid_status_id) && invoiceData?.cat1_einvoice_status && (
            <p className={`ml-4 text-sm font-semibold border rounded-full px-2 py-0.5 ${cat1EinvoiceStatusColor[invoiceData.cat1_einvoice_status?.toLowerCase()] || "text-[#055160] bg-[#E0F2FE]"}`}>
              Cat-1 Verification : <span className="capitalize">{invoiceData.cat1_einvoice_status}</span>
            </p>
          )}
          {invoiceData?.is_prioritised && latestRemarks(invoiceData?.invoice?.invoiceRemarks, invoiceData?.fileStatusHdr?.fuid_status_id, invoiceData?.invoice?.company_verification_status) && (
            <p className="ml-4 text-[#055160] text-sm font-semibold border bg-[#E0F2FE] rounded-full px-2 py-0.5">{latestRemarks(invoiceData?.invoice?.invoiceRemarks, invoiceData?.fileStatusHdr?.fuid_status_id, invoiceData?.invoice?.company_verification_status)}</p>
          )}
          {/* MEDVOL: M10-11303 */}
          {invoiceData?.escalations?.length > 0 && (() => {
            const action = invoiceData.escalations[0]?.escalated_action;
            const actionMap: Record<string, string> = {
              pending: "Cmp Esc - P",
              accepted: "Cmp Esc - A",
              rejected: "Cmp Esc - R",
            };

            return actionMap[action] ? (
              <p className="ml-4 text-[#055160] text-sm font-semibold border bg-[#E0F2FE] rounded-full px-2 py-0.5">
                {actionMap[action]}
              </p>
            ) : null;
          })()}
          {/* MEDVOL: M10-11303 */}
        </div>

        <div className="flex items-center gap-x-2">
          {viewDetails && (
            <Button
              className="h-10 text-white bg-[#8051FF] shadow-sm"
              onClick={() => {
                // Status 2 invoices open in view-only mode (no Confirm Invoice button).
                let isViewOnly = false;
                if (invoiceData?.upload_type == 'INST' && invoiceData?.company_code !== 10007 && invoiceData?.module_code !== 4) {
                  toast({
                    description: "Institution Order Only for LaRanon.",
                    variant: "destructive",
                  });
                  return;
                }
                if (!isFuidRejectionReview && invoiceData?.upload_type == 'INST' && invoiceData?.company_code == 10007 && invoiceData?.orderCodes?.length) {
                  toast({
                    description: "Invalid Institution Order for LaRanon.",
                    variant: "destructive",
                  });
                  return;
                }
                //   if (invoiceData?.company_code == 10007 && invoiceData?.upload_type == 'NMV' ) {
                //   toast({
                //     description: "Non-Medvol for LaRanon Cannot entered in V2.",
                //     variant: "destructive",
                //   });
                //   return;
                // }
                // M10-13620
                if (invoiceData?.created_date && (Date.now() - new Date(invoiceData.created_date).getTime()) <= 2 * 60 * 60 * 1000 && idTokenDetails?.["custom:mv_role"] == 'Invoice Entry') {
                  toast({
                    description: "The file was recently uploaded and is still being processed. You will be able to enter this file after 2 hours from the upload time.",
                    variant: "destructive",
                  });
                  return;
                }
                // M10-13620
                // REJECTION-REVIEW-WORKFLOW: original user is blocked from entering
                // while a rejection review is pending. The assigned reviewer accesses
                // the same invoice via the Rejection Review tab (isFuidRejectionReview).
                if (isRejectionPending && !isFuidRejectionReview) {
                  toast({
                    description: "Invoice Rejected — awaiting reviewer action. Entry is blocked.",
                    variant: "destructive",
                  });
                  return;
                }
                // Invoice Entered (status 5) can only be viewed in the approval screen —
                // blocked here even for the Rejection Review "view" bypass below.
                if (invoiceData?.fileStatusHdr?.fuid_status_id === 5) {
                  toast({
                    description: "Invoice Entered status can be viewed in the approval screen",
                    variant: "destructive",
                  });
                  return;
                }
                // MEDVOL: M10-11303 changes ========================================
                // REJECTION-REVIEW-WORKFLOW: in review mode the assigned reviewer
                // must be able to open the invoice regardless of its current status
                // (status/escalation guards below are skipped).
                if (!isFuidRejectionReview) {
                  if (invoiceData?.escalations?.length > 0 && invoiceData?.escalations?.[0]?.escalated_action === 'pending') {
                    toast({
                      description: "The issue is escalated; action is awaited from the company's end.",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (invoiceData?.escalations?.length > 0 && invoiceData?.escalations?.[0]?.escalated_action === 'rejected') {
                    toast({
                      description: "The company has reviewed the issue and decided to reject this FUID.",
                      variant: "destructive",
                    });
                    return;
                  }
                  // MEDVOL: M10-11303 changes ========================================
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 2) {
                    // Allow opening, but in view-only mode (Confirm Invoice hidden).
                    isViewOnly = true;
                  }
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 6) {
                    toast({
                      description: "Waiting For Approval cannot be viewed in the entry screen",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 8) {
                    toast({
                      description: "Approved invoices can be viewed in the approval screen",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 15) {
                    toast({
                      description: "PO invoices can be viewed in the approval screen",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 9) {
                    toast({
                      description: "This invoice has been handled in v1",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (invoiceData?.fileStatusHdr?.fuid_status_id === 24) {
                    toast({
                      description: "Waiting For Rate Approval cannot be viewed in the entry screen",
                      variant: "destructive",
                    });
                    return;
                  }
                }
                if (approvalScreen) {
                  //M10-9862
                  naviagate(`/transactions/invoice/${invoiceData?.stockist_invoice_attachment_id}/${1}`, {
                    state: {
                      CompanyCode: invoiceData?.company_code,
                      fuidRejectionReviewMode: isFuidRejectionReview,
                      viewOnly: isViewOnly,
                    },
                  });
                } else {
                  naviagate(`/transactions/invoice/${invoiceData?.stockist_invoice_attachment_id}/${0}`, {
                    state: {
                      CompanyCode: invoiceData?.company_code,
                      fuidRejectionReviewMode: isFuidRejectionReview,
                      viewOnly: isViewOnly,
                    },
                  });
                }
              }}
              module={fineGrainedPermissionsKeys.INVOICE["VIEW DETAILS"].module}
              action={fineGrainedPermissionsKeys.INVOICE["VIEW DETAILS"].action}
            >
              View Details
            </Button>
          )}
          {
            <div className="w-10 h-10 text-white shadow-sm">
              <InvoiceDropdown
                placeholder="..."
                menuItems={filteredMenuItems}
                displayKey="label"
                onOptionClick={handleOptionClick}
                currentSelected={undefined}
                setModalStates={setModalStates}
              />
            </div>
          }
          {isExpandable && (
            <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          )}
        </div>
      </header>
      <div className="flex items-center gap-x-2 ml-4">
        <img className="w-6 h-6 ml-1" src={Contact} alt="person-img" />
        <span className="text-[#49484C] text-sm">Assigned to</span>
        <div className="w-8 h-8 bg-[#8051FF] flex items-center justify-center text-[#fff] rounded-full">
          {invoiceData?.InvoiceAssignment?.user_name?.slice(0, 2)}
        </div>
        <span className="text-[#49484C] text-sm">{invoiceData?.InvoiceAssignment?.user_name}</span>
        {isRejectionPending && invoiceData?.rejectionReviewAssignment?.user_name &&
          <>
            <img className="w-6 h-6 ml-10" src={Contact} alt="person-img" />
            <span className="text-[#49484C] text-sm">Escalated to</span>
            <div className="w-10 h-10 bg-[#8051FF] flex items-center justify-center text-[#fff] rounded-full">
              {invoiceData?.rejectionReviewAssignment?.user_name?.slice(0, 2)}
            </div>
            <span className="text-[#49484C] text-sm">{invoiceData?.rejectionReviewAssignment?.user_name}</span>
          </>}
      </div>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
        style={{ transitionProperty: "max-height, opacity" }}
      >
        <div className={"grid grid-cols-1 w-[80%] gap-x-10 px-5 py-3 mt-5 xl:grid-cols-2 gap-y-5"}>
          {!!data &&
            Object.keys(data)?.length > 0 &&
            Object.entries(data)?.map(
              ([key, value]) =>
                typeof value === "string" &&
                value !== "" && (
                  <div key={key?.toString()} className={"grid grid-cols-2 -space-x-10 -space-y-1 text-sm xl:grid-cols-2"}>
                    <p className="text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-sm leading-[0.02rem] font-normal not-italic">
                      {switchString(key)} :
                    </p>
                    <div className="mr-auto">
                      {key === "Counter Code" ? (
                        <a
                          className="text-gray-900 hover:text-[#6b40d6]"
                          href={`/masters/counters/details/?counter_code=${value}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => {
                            dispatch(counterActions.setClickType("row"));
                            dispatch(counterActions.setSelectedCounterData({}));
                            window.localStorage.setItem("counterOrderId", value);
                            window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                          }}
                        >
                          {value}
                        </a>
                      ) : key === "Order Number" && value !== "-" ? (
                        value?.split(",").map((orderCode: string, index: number) => {
                          const trimmedCode = orderCode.trim();
                          return (
                            <span key={index}>
                              <a
                                className="text-gray-900 hover:text-[#6b40d6] w-fit"
                                href={`/transactions/orders/info/${trimmedCode}/1`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => {
                                  window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                                  window.localStorage.setItem("company_code", invoiceData?.company_code);
                                }}
                              >
                                {trimmedCode}
                              </a>
                              {index < value.split(",").length - 1 && ", "}
                            </span>
                          );
                        })
                      ) : checkDataType ? (
                        <p className="text-[#1B1A1F] mr-auto">
                          {typeof value === "string" ? verifyStringType(value) : ""}
                        </p>
                      ) : (
                        <p className="text-[#1B1A1F] mr-auto">{value}</p>
                      )}
                    </div>
                  </div>
                )
            )}
        </div>
        {shouldShowRejectionDetails(invoiceData) && <RejectionDetailsCard invoiceData={invoiceData} />}
      </div>
    </div>
  );
};

export default InvoiceHomeDetailCard;
